export enum ItemType {
  Good = 'Good',
  Service = 'Service',
}
export class ItemDimensions {
  width: number;
  height: number;
  length: number;
  unit: string;
}

export class ItemWeight {
  amount: number;
  unit: string;
}

export class Item {
  itemId: number;
  itemType: ItemType;
  name: string;
  sku?: string;
  unit: string;
  returnable: boolean;
  picture?: string;
  dimensions?: ItemDimensions;
  weight?: ItemWeight;
  manufacturer?: string;
  brand?: string;
  sellable: boolean;
  sellingPrice?: number;
  sellingAccount?: string;
  sellingDescription?: string;
  sellingTax?: number;
  purchasable: boolean;
  purchasingPrice?: number;
  purchasingAccount?: string;
  purchasingDescription?: string;
  purchasingTax?: number;
  purchasingPreferredVendor?: string;
  trackInventory: boolean;
  inventoryAccount?: string;
  reorderPoint?: number;
  openingStock?: number;
  openingStockRate?: number;
}
